import moment from 'moment'

import { formatters } from '@Components/hierarchical-report/Layout'

import { getGroupbyOption } from './collectionGroupby'

export const CUSTOM_FILTER_ENTITY = 'custom'

const VALUE_SHAPES = {
  scalar: 'scalar',
  list: 'list',
  range: 'range',
  none: 'none',
}

export const CUSTOM_FILTER_OPERATORS = [
  { value: 'eq', label: 'Equals', group: 'Equality', shape: VALUE_SHAPES.scalar },
  { value: 'neq', label: 'Not equals', group: 'Equality', shape: VALUE_SHAPES.scalar },
  { value: 'in', label: 'Is one of', group: 'Equality', shape: VALUE_SHAPES.list },
  { value: 'nin', label: 'Is not one of', group: 'Equality', shape: VALUE_SHAPES.list },

  { value: 'gt', label: 'Greater than', group: 'Range', shape: VALUE_SHAPES.scalar },
  { value: 'gte', label: 'Greater or equal', group: 'Range', shape: VALUE_SHAPES.scalar },
  { value: 'lt', label: 'Less than', group: 'Range', shape: VALUE_SHAPES.scalar },
  { value: 'lte', label: 'Less or equal', group: 'Range', shape: VALUE_SHAPES.scalar },
  { value: 'between', label: 'Between', group: 'Range', shape: VALUE_SHAPES.range },
  { value: 'notBetween', label: 'Not between', group: 'Range', shape: VALUE_SHAPES.range },

  { value: 'exists', label: 'Exists', group: 'Presence', shape: VALUE_SHAPES.none },
  { value: 'notExists', label: 'Does not exist', group: 'Presence', shape: VALUE_SHAPES.none },

  { value: 'contains', label: 'Contains', group: 'Text', shape: VALUE_SHAPES.scalar },
  { value: 'notContains', label: 'Does not contain', group: 'Text', shape: VALUE_SHAPES.scalar },
  { value: 'startsWith', label: 'Starts with', group: 'Text', shape: VALUE_SHAPES.scalar },
  { value: 'endsWith', label: 'Ends with', group: 'Text', shape: VALUE_SHAPES.scalar },
  { value: 'wildcard', label: 'Wildcard', group: 'Text', shape: VALUE_SHAPES.scalar },
  { value: 'regex', label: 'Regex', group: 'Text', shape: VALUE_SHAPES.scalar },

  { value: 'match', label: 'Matches', group: 'Full text', shape: VALUE_SHAPES.scalar },
  { value: 'notMatch', label: 'Does not match', group: 'Full text', shape: VALUE_SHAPES.scalar },
  { value: 'matchPhrase', label: 'Matches phrase', group: 'Full text', shape: VALUE_SHAPES.scalar },
]

export const DEFAULT_CUSTOM_FILTER_OPERATOR = 'eq'

export const COLLECTION_FIELDS = {
  impression: [
    { field: 'date', type: 'date', path: 'request.datetime', label: 'Date', group: 'Full Time' },
    {
      field: 'userSessionDate',
      type: 'date',
      path: 'user_session.created_at',
      label: 'User Session Date',
      group: 'User Session',
    },
    { field: 'pathContainerSlot', type: 'long', path: 'path_container_slot_id' },
    { field: 'experimentVersion', type: 'long', path: 'path_experiment_version' },
    { field: 'experiment', type: 'long', path: 'path_experiment_id' },
    { field: 'uniqUser', type: 'long', path: 'user.id' },
    { field: 'uniqPathSession', type: 'keyword', path: 'path_session_id' },
    { field: 'completed', type: 'boolean', path: 'completed' },
    { field: 'completedOrigin', type: 'keyword', path: 'completed_origin' },
    { field: 'uniqUserSession', type: 'long', path: 'user_session.id' },
    { field: 'registrationCompleted', type: 'boolean', path: 'user_session.registration_completed' },
    { field: 'duplicated', type: 'boolean', path: 'user_session.duplicated' },
    { field: 'offer', type: 'long', path: 'user_session.offer_id' },
    { field: 'organization', type: 'long', path: 'organization.id' },
    { field: 'site', type: 'long', path: 'site.id' },
    { field: 'path', type: 'long', path: 'path.id' },
    { field: 'page', type: 'long', path: 'page.id' },
    { field: 'pageVersion', type: 'keyword', path: 'survey.version' },
    { field: 'partner', type: 'keyword', path: 'page.type' },
    { field: 'slot', type: 'long', path: 'request.slot_position' },
    { field: 'city', type: 'keyword', path: 'user.city_key' },
    { field: 'state', type: 'keyword', path: 'user.state_key' },
    { field: 'emailDomain', type: 'keyword', path: 'user.email_domain' },
    { field: 'age', type: 'long', path: 'user.age' },
    { field: 'gender', type: 'keyword', path: 'user.gender' },
    { field: 'optout', type: 'boolean', path: 'optout' },
    { field: 'publisher', type: 'keyword', path: 'request.pid' },
    { field: 'sid1', type: 'keyword', path: 'request.sid1' },
    { field: 'sid2', type: 'keyword', path: 'request.sid2' },
    { field: 'device', type: 'keyword', path: 'request.device_type' },
    { field: 'allocation', type: 'long', path: 'request.allocation_id' },
    { field: 'pathUserProfile', type: 'keyword', path: 'path_user_profile_id' },
    { field: 'domain', type: 'keyword', path: 'request.domain' },
    { field: 'fraudVerification', type: 'long', path: 'path_session_fraud_verification' },
    { field: 'fraudScore', type: 'keyword', path: 'path_session_fraud_score' },
  ],
  session: [
    { field: 'date', type: 'date', path: 'created_at', label: 'Date', group: 'Full Time' },
    { field: 'uniqUser', type: 'long', path: 'user_id' },
    { field: 'site', type: 'long', path: 'site_id' },
    { field: 'organization', type: 'long', path: 'organization_id' },
    { field: 'publisher', type: 'long', path: 'publisher_id' },
    { field: 'subId', type: 'keyword', path: 'sid1' },
    { field: 'subId2', type: 'keyword', path: 'sid2' },
    { field: 'subId3', type: 'keyword', path: 'sid3' },
    { field: 'path', type: 'long', path: 'path_id' },
    { field: 'slot', type: 'integer', path: 'slot_position' },
    { field: 'allocation', type: 'long', path: 'allocation_id' },
    { field: 'offer', type: 'long', path: 'offer_id' },
    { field: 'form', type: 'long', path: 'form_id' },
    { field: 'post', type: 'long', path: 'post_id' },
    { field: 'post_version', type: 'long', path: 'post_version_id' },
    { field: 'post_target', type: 'long', path: 'post_target_id' },
    { field: 'conversiontype', type: 'keyword', path: 'conversiontype' },
    { field: 'payouttype', type: 'keyword', path: 'payouttype' },
    { field: 'campaignid', type: 'keyword', path: 'campaignid' },
    { field: 'externalid', type: 'keyword', path: 'externalid' },
    { field: 'domain', type: 'keyword', path: 'domain' },
    { field: 'converted', type: 'boolean', path: 'converted' },
    { field: 'isLoss', type: 'boolean', path: 'is_loss' },
    { field: 'optout', type: 'boolean', path: 'optout' },
    { field: 'duplicated', type: 'boolean', path: 'duplicated' },
    { field: 'duplicatedData', type: 'boolean', path: 'duplicated_data' },
    { field: 'duplicatedClick', type: 'boolean', path: 'duplicated_click' },
    { field: 'dupeDaysDelta', type: 'integer', path: 'dupe_days_delta' },
    { field: 'registration_completed', type: 'boolean', path: 'registration_completed' },
    { field: 'registrationConsent', type: 'boolean', path: 'registration_consent' },
    { field: 'registrationCount', type: 'integer', path: 'user_registration_count' },
    { field: 'registrationTotalSteps', type: 'integer', path: 'registration_total_step' },
    { field: 'registrationLastStep', type: 'integer', path: 'registration_step' },
    { field: 'skipRegistration', type: 'boolean', path: 'skip_registration' },
    { field: 'tcpaConsent', type: 'boolean', path: 'tcpaconsent' },
    { field: 'formStep', type: 'integer', path: 'form_step' },
    { field: 'formConversionStep', type: 'integer', path: 'form_conversion_step' },
    { field: 'fraud_verification', type: 'integer', path: 'fraud_verification' },
    { field: 'fraudScore', type: 'keyword', path: 'fraudscore' },
    { field: 'emailVerification', type: 'integer', path: 'email_verification' },
    { field: 'addressVerification', type: 'integer', path: 'address_verification' },
    { field: 'botVerification', type: 'integer', path: 'bot_verification' },
    { field: 'postalVerification', type: 'integer', path: 'postal_verification' },
    { field: 'phoneVerification', type: 'integer', path: 'phone_verification' },
    { field: 'device', type: 'keyword', path: 'device' },
    { field: 'os', type: 'keyword', path: 'os' },
    { field: 'browser', type: 'keyword', path: 'browser' },
    { field: 'city', type: 'keyword', path: 'user_city' },
    { field: 'state', type: 'keyword', path: 'user_state' },
    { field: 'emaildomain', type: 'keyword', path: 'user_emaildomain' },
    { field: 'age', type: 'long', path: 'user_age_int' },
    { field: 'age_legacy', type: 'keyword', path: 'user_age' },
    { field: 'gender', type: 'keyword', path: 'user_gender' },
    { field: 'rev__origin', type: 'keyword', path: 'revenues.origin', nested: 'revenues' },
    { field: 'rev__externalId', type: 'keyword', path: 'revenues.transid', nested: 'revenues' },
    { field: 'rev__integrationId', type: 'long', path: 'revenues.integration_id', nested: 'revenues' },
  ],
  bucketrans: [
    { field: 'date', type: 'date', path: 'ref_date', label: 'Date', group: 'Full Time' },
    { field: 'uniqUser', type: 'long', path: 'user_id' },
    { field: 'uniqPathSession', type: 'keyword', path: 'path_session_id' },
    { field: 'uniqUserSession', type: 'keyword', path: 'usession_id' },
    { field: 'action', type: 'keyword', path: 'action' },
    { field: 'organization', type: 'long', path: 'organization_id' },
    { field: 'site', type: 'long', path: 'site_id' },
    { field: 'allocation', type: 'long', path: 'allocation_id' },
    { field: 'bucket', type: 'long', path: 'bucket_id' },
    { field: 'publisher', type: 'long', path: 'publisher_id' },
    { field: 'subid', type: 'keyword', path: 'subid' },
    { field: 'pekey', type: 'keyword', path: 'pekey' },
  ],
  integration: [
    {
      field: 'date',
      type: 'date',
      path: 'delivery_date',
      label: 'Delivery Date',
      group: 'Date Intervals',
    },
    {
      field: 'userSessionDate',
      type: 'date',
      path: 'u_session_created_date',
      label: 'User Session Date',
      group: 'Date Intervals',
    },
    { field: 'site', type: 'integer', path: 'site_id' },
    { field: 'sid1', type: 'keyword', path: 'sid1' },
    { field: 'publisher', type: 'long', path: 'publisher_id' },
    { field: 'allocation', type: 'long', path: 'allocation_id' },
    { field: 'type', type: 'keyword', path: 'integration_type' },
    { field: 'registration_completed', type: 'boolean', path: 'registration_completed' },
    { field: 'registration_consent', type: 'boolean', path: 'registration_consent' },
    { field: 'integration', type: 'long', path: 'integration_id' },
    { field: 'status_code', type: 'integer', path: 'status_code' },
    { field: 'latency', type: 'long', path: 'latency' },
    { field: 'active', type: 'boolean', path: 'active' },
    { field: 'preping', type: 'boolean', path: 'twyne_preping' },
    { field: 'vendor', type: 'keyword', path: 'vendor' },
    { field: 'success', type: 'boolean', path: 'success' },
    { field: 'session', type: 'long', path: 'u_session_id' },
    { field: 'preping_success', type: 'boolean', path: 'preping_success' },
    { field: 'rules_result', type: 'boolean', path: 'rules_result' },
    { field: 'trigger', type: 'keyword', path: 'trigger' },
    { field: 'fail', type: 'boolean', path: 'fail' },
  ],
}

const TYPE_OPERATORS = {
  date: ['eq', 'neq', 'in', 'nin', 'gt', 'gte', 'lt', 'lte', 'between', 'notBetween', 'exists', 'notExists'],
  long: ['eq', 'neq', 'in', 'nin', 'gt', 'gte', 'lt', 'lte', 'between', 'notBetween', 'exists', 'notExists'],
  integer: ['eq', 'neq', 'in', 'nin', 'gt', 'gte', 'lt', 'lte', 'between', 'notBetween', 'exists', 'notExists'],
  keyword: [
    'eq', 'neq', 'in', 'nin',
    'contains', 'notContains', 'startsWith', 'endsWith', 'wildcard', 'regex',
    'match', 'notMatch', 'matchPhrase',
    'exists', 'notExists',
  ],
  boolean: ['eq', 'neq', 'exists', 'notExists'],
}

export const BOOLEAN_VALUE_OPTIONS = [
  { value: 'true', label: 'Yes' },
  { value: 'false', label: 'No' },
]

const PATH_GROUPS = [
  { prefix: 'request.', group: 'Request' },
  { prefix: 'user_session.', group: 'User Session' },
  { prefix: 'user.', group: 'Consumer' },
  { prefix: 'survey.', group: 'Midpath' },
  { prefix: 'revenues.', group: 'Revenue' },
]

function titleCase(text) {
  return text.replace(/(^|\s)([a-z])/g, (_, prefix, letter) => `${prefix}${letter.toUpperCase()}`)
}

function resolveFieldLabel(collection, alias) {
  const groupbyLabel = getGroupbyOption(collection, alias)?.label
  if (groupbyLabel) return groupbyLabel

  return titleCase(formatters.groupsText(alias))
}

function resolveFieldGroup(collection, alias, path = '') {
  const groupbyGroup = getGroupbyOption(collection, alias)?.group
  if (groupbyGroup) return groupbyGroup

  return PATH_GROUPS.find(entry => path.startsWith(entry.prefix))?.group || 'Other'
}

export function getCollectionFieldDefinitions(collection) {
  return COLLECTION_FIELDS[collection] || []
}

export function getFieldDefinition(collection, field) {
  return getCollectionFieldDefinitions(collection).find(item => item.field === field)
}

export function getCollectionFields(collection) {
  return getCollectionFieldDefinitions(collection).map(({ field, path, label, group }) => ({
    value: field,
    label: label || resolveFieldLabel(collection, field),
    rightLabel: path,
    group: group || resolveFieldGroup(collection, field, path),
  }))
}

export function getFieldType(collection, field) {
  return getFieldDefinition(collection, field)?.type || null
}

export function getFieldPath(collection, field) {
  return getFieldDefinition(collection, field)?.path || null
}

export function getFieldOperators(collection, field) {
  const type = getFieldType(collection, field)
  const allowed = TYPE_OPERATORS[type]
  if (!allowed) return CUSTOM_FILTER_OPERATORS

  return CUSTOM_FILTER_OPERATORS.filter(operator => allowed.includes(operator.value))
}

export function isOperatorAllowed(collection, field, operator) {
  return getFieldOperators(collection, field).some(item => item.value === operator)
}

export function getFieldLabel(collection, field) {
  return getCollectionFields(collection).find(item => item.value === field)?.label || field || ''
}

export function getOperator(operator) {
  return CUSTOM_FILTER_OPERATORS.find(item => item.value === operator)
}

export function getOperatorLabel(operator) {
  return getOperator(operator)?.label || operator || ''
}

export function getOperatorShape(operator) {
  return getOperator(operator)?.shape || VALUE_SHAPES.scalar
}

export function isValuelessOperator(operator) {
  return getOperatorShape(operator) === VALUE_SHAPES.none
}

export function isListOperator(operator) {
  return getOperatorShape(operator) === VALUE_SHAPES.list
}

export function isRangeOperator(operator) {
  return getOperatorShape(operator) === VALUE_SHAPES.range
}

function parseValue(value) {
  const text = String(value ?? '').trim()
  if (!text) return text
  if (text === 'true') return true
  if (text === 'false') return false

  const numeric = Number(text)
  return Number.isNaN(numeric) ? text : numeric
}

function parseValueList(value) {
  return String(value ?? '')
    .split(',')
    .map(item => parseValue(item))
    .filter(item => item !== '')
}

export function isCustomFilterComplete(filter) {
  if (!filter?.field || !filter?.operator) return false

  const { operator, value } = filter

  if (isValuelessOperator(operator)) return true
  if (isListOperator(operator)) return parseValueList(value).length > 0
  if (isRangeOperator(operator)) return parseValueList(value).length === 2

  return String(value ?? '').trim().length > 0
}

export function customFilterToCondition(filter) {
  if (!isCustomFilterComplete(filter)) return null

  const { field, operator, value } = filter

  if (isValuelessOperator(operator)) return { field, operator }
  if (isListOperator(operator) || isRangeOperator(operator)) {
    return { field, operator, value: parseValueList(value) }
  }

  return { field, operator, value: parseValue(value) }
}

export function conditionToCustomFilter({ field, operator, value }) {
  return {
    field,
    operator: operator || DEFAULT_CUSTOM_FILTER_OPERATOR,
    value: Array.isArray(value) ? value.join(', ') : String(value ?? ''),
  }
}

export const DISPLAY_DATE_MASK = 'MM/DD/YYYY HH:mm'

function formatDisplayValue(collection, filter) {
  const text = String(filter?.value ?? '').trim()
  if (!text || getFieldType(collection, filter?.field) !== 'date') return text

  const separator = isRangeOperator(filter?.operator) ? ' - ' : ', '

  return text
    .split(',')
    .map(item => {
      const parsed = moment.parseZone(item.trim())
      return parsed.isValid() ? parsed.format(DISPLAY_DATE_MASK) : item.trim()
    })
    .join(separator)
}

export function getCustomFilterSummary(collection, filter) {
  const field = getFieldLabel(collection, filter?.field)
  const operator = getOperatorLabel(filter?.operator)

  if (isValuelessOperator(filter?.operator)) return `${field} ${operator}`.trim()

  return `${field} ${operator} ${formatDisplayValue(collection, filter)}`.trim()
}
